export const mainurl = process.env.REACT_APP_MAINURL;
export const chatUrl = process.env.REACT_APP_CHATURL;

export const api = {
  //auth
  Login: `${mainurl}loginwithrole`,
  register: `${mainurl}register`,
  sidebar: `${mainurl}get_role_permission_by_user`,
  // sidebar:
  // 'https://logisticsshipp.dotserviz.com/api/v1/role_permission/get_role_permission_by_user',
  verify_user: `${mainurl}verify_user`,
  send_opt: `${mainurl}send_opt`,
  sendforgotpassword: `${mainurl}sendforgotpassword`,
  updateforgotpassword: `${mainurl}updateforgotpassword`,
  updateProfile: `${mainurl}profile/update`,
  changePassword: `${mainurl}changePassword`,
  changeEmail: `${mainurl}changeEmail`,
  share_link: `${mainurl}share_link`,
  get_services: `${mainurl}get_services`,
  get_sub_services: `${mainurl}get_sub_services`,
  save_subservice: `${mainurl}save_subservice`,
  delete_sub_service: `${mainurl}delete_sub_service`,
  get_service_details: `${mainurl}get_service_details`,
  update_customer_services: `${mainurl}update_customer_services`,
  get_service_detail_steps: `${mainurl}get_service_detail_steps`,
  save_service_details: `${mainurl}save_service_details`,
  delete_customer_service: `${mainurl}delete_customer_service`,
  send_service_link: `${mainurl}send_service_link`,
  custom_steps_add: `${mainurl}custom_steps_add`,
  get_steps: `${mainurl}get_steps`,
  get_service_document: `${mainurl}get_service_document`,
  save_service_document: `${mainurl}save_service_document`,
  delete_service_document: `${mainurl}delete_service_document`,
  get_service_message: `${mainurl}get_service_message`,
  send_service_message: `${mainurl}send_service_message`,
  update_notes: `${mainurl}update_notes`,
  delete_user: `${mainurl}delete_user`,
  get_existing_customers: `${mainurl}get_existing_customers`
};
